// Sparkline — mini-chart pra cards KPI ou tabelas.
// Mostra tendência sem eixos, sem labels. Cor segue tema.
import { Area, AreaChart, ResponsiveContainer } from "recharts";
import { chartTheme } from "./theme.ts";

interface Props {
  data: number[];
  height?: number;
  color?: string;
  /** "up" = bom subir (verde); "down" = bom descer (verde quando cai); "neutral" = sempre primary */
  trend?: "up" | "down" | "neutral";
}

export function Sparkline({ data, height = 32, color, trend = "neutral" }: Props) {
  if (!data || data.length < 2) return <div style={{ height, opacity: 0.3, fontSize: ".7rem", color: "var(--text-muted)" }}>—</div>;
  const t = chartTheme();
  const isUpTrend = data[data.length - 1]! > data[0]!;
  const stroke = color ?? (
    trend === "up"   ? (isUpTrend ? t.green : t.red) :
    trend === "down" ? (isUpTrend ? t.red   : t.green) :
    t.primary
  );

  const points = data.map((v, i) => ({ i, v }));
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={points} margin={{ top: 2, right: 0, bottom: 0, left: 0 }}>
        <defs>
          <linearGradient id={`spark-${stroke.replace(/#/g, "")}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={stroke} stopOpacity={0.3}/>
            <stop offset="95%" stopColor={stroke} stopOpacity={0}/>
          </linearGradient>
        </defs>
        <Area
          type="monotone"
          dataKey="v"
          stroke={stroke}
          strokeWidth={1.6}
          fill={`url(#spark-${stroke.replace(/#/g, "")})`}
          isAnimationActive={false}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
